import { Store, toImmutable, Immutable } from 'nuclear-js';

import Actions from '../actions';
import { findCurrentTerm } from 'utils/terms';
import { futureTermsSetup } from 'utils/terms';

import DataUtils from '../utils';

export default Store({
    getInitialState() {
        return toImmutable({
            terms: Immutable.List(),
            //
            // ritQuintiles: {
            //       {termNumber: XX, subject: Y, grade: Z, weeks: Q}:
            //              {
            //                  <percentile1>: rit1,
            //                  <percentile2>: rit2,
            //                  etc...
            //               }
            //       }
            // }
            currentAcademicYear: Immutable.Map(),
            //    "terms": {
            //        "SPRING": {
            //            "seasonDescription": "SPRING",
            //           "name": "Spring 2016-2017",
            //            "startDate": 1488326400000,
            //            "endDate": 1497484800000,
            //            "testWindowStartDate": 1488326400000,
            //            "testWindowEndDate": 1497484800000,
            //            "termNumber": 201702,
            //            "instructionalWeek": 32,
            //            "businessIdentifier": "11ddb944-02fe-4dfc-b015-9cf5c7b940f8",
            //            "isCurrent": false
            //        },
            //        "WINTER": {
            //            "seasonDescription": "WINTER",
            //            "name": "Winter 2016-2017",
            //            "startDate": 1480550400000,
            //            "endDate": 1488240000000,
            //            "testWindowStartDate": 1480550400000,
            //            "testWindowEndDate": 1488240000000,
            //            "termNumber": 201701,
            //            "instructionalWeek": 20,
            //            "businessIdentifier": "7a08feaa-5abc-465f-b1e2-df7f48e3d3c9",
            //            "isCurrent": false
            //        },
            //        "FALL": {
            //            "seasonDescription": "FALL",
            //            "name": "Fall 2016-2017",
            //            "startDate": 1467244800000,
            //            "endDate": 1480464000000,
            //            "testWindowStartDate": 1467244800000,
            //            "testWindowEndDate": 1480464000000,
            //            "termNumber": 201604,
            //            "instructionalWeek": 4,
            //            "businessIdentifier": "722edd43-27a8-4e5b-9664-c3936f64d748",
            //            "isCurrent": false
            //        },
            //        "SUMMER": {
            //            "seasonDescription": "SUMMER",
            //            "name": "Summer 2016-2017",
            //            "startDate": 1497571200000,
            //            "endDate": 1502668800000,
            //            "testWindowStartDate": 1497571200000,
            //            "testWindowEndDate": 1502668800000,
            //            "termNumber": 201703,
            //            "instructionalWeek": 0,
            //            "businessIdentifier": "9229f4a6-a1ed-4213-b22d-b848eec54255",
            //            "isCurrent": true
            //        }
            //   }
            currentTerm: Immutable.Map(),
            // futureTermsSetup: boolean - true if partner has terms set up past the current term
            ritQuintiles: Immutable.Map(),
            //
            // districtAverages: {
            //       {termNumber: XX, subject: X, grade: Y} :
            //          { mean: <mean>
            //            median: <median>,
            //            standardDeviation: <stdDev>,
            //            count: <count>
            //          }
            // }
            districtAverages: Immutable.Map(),
            //
            // <type>LinkingStudy: { geographicLocation: "OH",
            //                      seasonNumber: 2,
            //                      study: "OAA",
            //                      studyDisplayName: "Ohio Achievement Assessment",
            //                      studyType: "STATE",
            //                      url: "https://www.nwea.org/resources/ohio-linking-study/",
            //                      version: 0,
            //                      year: 2012
            linkingStudies: Immutable.List(),
            // {
            //     "partnerStandardCode": "CCSS",
            //     "strands": [{
            //             "description": "Length, Area, Volume, and Coordinate Geometry",
            //             "strandBid": "c5240664-a276-11e4-a648-b00594f9b4fa",
            //             "order": 2,
            //             "schema": "MLRV",
            //             "scale": "MATHEMATICS"
            //         },
            //         {... }
            //     ],
            //     "framework": [{
            //             "bid": "c5240665-a276-11e4-9915-b00594f9b4fa",
            //             "strandBid": "c5240664-a276-11e4-a648-b00594f9b4fa",
            //             "grade": "KINDERGARTEN",
            //             "order": 0,
            //             "scale": "MATHEMATICS",
            //             "name": "Identify measurable attributes of an object.",
            //             "ccssCode": "K.MD.A.1",
            //             "skillDescriptors": null
            //         },
            //         {... }
            //     ],
            //     "mapStandardData": [{
            //             "scale": "LANGUAGE",
            //             "gradeRange": "TWO_TO_TWELVE",
            //             "goalName": "Language: Understand, Edit for Grammar, Usage",
            //             "goalKey": "93640",
            //             "strandBids": [
            //                 "a904c9d0-a275-11e4-8af9-b00594f9b4fa",
            //                 "a904f0de-a275-11e4-9498-b00594f9b4fa"
            //             ],
            //             "strandSchemaEnum": "MLRV"
            //         },
            //         {... }
            //     ],
            //     "showStandardCodes": true
            //     "topicData": [
            //          {
            //              "scale": "MATHEMATICS",
            //              "topicName": "Whole Numbers: Represent and Solve Word Problems",
            //              "topicId": "119",
            //              "skillBids": [
            //                  "c5242d7a-a276-11e4-aa71-b00594f9b4fa",
            //                  "...",
            //                  "c525b416-a276-11e4-97ed-b00594f9b4fa"
            //              ],
            //              "subcategories": []
            //          },
            //          {
            //              "scale": "READING",
            //              "topicName": "Characterization",
            //              "topicId": "69",
            //              "skillBids": [
            //                  "dec2409b-a276-11e4-a147-b00594f9b4fa",
            //                  "...",
            //                  "dec72298-a276-11e4-ab53-b00594f9b4fa"
            //              ],
            //              "subcategories": [
            //                  {
            //                      "subcategoryBid": "88827058-162f-43e0-87c9-d846ca2e6a16",
            //                      "strandBid": "dec267a3-a276-11e4-ac4e-b00594f9b4fa",
            //                      "grade": "FOUR"
            //                  },
            //                  {...},
            //                  {
            //                      "subcategoryBid": "88827058-162f-43e0-87c9-d846ca2e6a16",
            //                      "strandBid": "dec24096-a276-11e4-831e-b00594f9b4fa",
            //                      "grade": "FOUR"
            //                  }
            //              ]
            //          },
            //      ]
            // }
        });
    },

    initialize() {
        this.on(Actions.partner.STORE_TERMS, storeTermsInformation);
        this.on(Actions.partner.STORE_CURRENT_ACADEMIC_YEAR, storeCurrentAcademicYearInformation);
        this.on(Actions.partner.STORE_RIT_QUINTILES, storeRitQuintiles);
        this.on(Actions.partner.STORE_DISTRICT_AVERAGES, storeDistrictAverages);
        this.on(Actions.partner.STORE_LINKING_STUDIES_FOR_PARTNER, storeLinkingStudiesForPartner);
        this.on(Actions.runtime.CLEAR_STATE, (state) => this.getInitialState());
        this.on(Actions.student.CLEAR_STUDENT_DATA, clearStudentData);
    },

    deserialize(state) {
        const newStore = toImmutable(state);
        const revisedStore = newStore.withMutations((newState) => {
            // RIT Quintiles
            const quintileList = newStore.get('ritQuintiles', Immutable.Map());
            quintileList.forEach((ritDataInStringForm, keyInStringForm) => {
                if (typeof keyInStringForm == 'string') {
                    // Guards against pre-converted data causing an error.
                    newState = newState.deleteIn(['ritQuintiles', keyInStringForm]);
                    const keyInMapForm = toImmutable(JSON.parse(keyInStringForm.substring(4)));
                    let ritValues = Immutable.Map().withMutations((ritMap) => {
                        ritDataInStringForm.forEach((value, key) => {
                            ritMap = ritMap.set(parseInt(key), value);
                        });
                    });
                    newState = newState.setIn(['ritQuintiles', keyInMapForm], ritValues);
                } // if (typeof keyInStringForm == "string")
            });
            // District Average data
            const districtAverageList = newStore.get('districtAverages', Immutable.Map());
            districtAverageList.forEach((districtData, keyInStringForm) => {
                if (typeof keyInStringForm == 'string') {
                    // Guards against pre-converted data causing an error.
                    newState = newState.deleteIn(['districtAverages', keyInStringForm]);
                    const keyInMapForm = toImmutable(JSON.parse(keyInStringForm.substring(4)));
                    newState = newState.setIn(['districtAverages', keyInMapForm], districtData);
                }
            });
            // Learning Continuum
            const lcList = newStore.get('learningContinuum', Immutable.Map());
            lcList.forEach((lcData, lcKey) => {
                // Goal Structure - Goals
                let goalsList = lcData.getIn(['goalStructure', 'goals'], Immutable.Map());
                goalsList.forEach((goalData, termString) => {
                    newState = newState.deleteIn(['learningContinuum', lcKey, 'goalStructure', 'goals', termString]);
                    newState = newState.setIn(
                        ['learningContinuum', lcKey, 'goalStructure', 'goals', parseInt(termString)],
                        goalData
                    );
                });
                // Goal Structure - Child Goals
                goalsList = lcData.getIn(['goalStructure', 'childGoals'], Immutable.Map());
                goalsList.forEach((goalData, termString) => {
                    newState = newState.deleteIn([
                        'learningContinuum',
                        lcKey,
                        'goalStructure',
                        'childGoals',
                        termString,
                    ]);
                    newState = newState.setIn(
                        ['learningContinuum', lcKey, 'goalStructure', 'childGoals', parseInt(termString)],
                        goalData
                    );
                });
                // Topics
                let topicsList = lcData.get('topics', Immutable.Map());
                topicsList.forEach((topicData, keyString) => {
                    newState = newState.deleteIn(['learningContinuum', lcKey, 'topics', keyString]);
                    newState = newState.setIn(['learningContinuum', lcKey, 'topics', parseInt(keyString)], topicData);
                });
                // Learning Statements
                let learningStatements = lcData.get('learningStatements', Immutable.Map());
                learningStatements.forEach((statementData, keyString) => {
                    newState = newState.deleteIn(['learningContinuum', lcKey, 'learningStatements', keyString]);
                    newState = newState.setIn(
                        ['learningContinuum', lcKey, 'learningStatements', parseInt(keyString)],
                        statementData
                    );
                });
            });
        });
        return revisedStore;
    },
});

export function clearStudentData(state) {
    return state.withMutations((s) => {
        s.set('ritQuintiles', Immutable.Map());
        s.set('districtAverages', Immutable.Map());
        s.set('learningContinuum', Immutable.Map());
    });
}

export function storeDistrictAverages(state, averages) {
    // averages format:
    // [
    //    {
    //       termNumber: 201504,
    //       subject: 1,
    //       grade: 4,
    //       mean: 194.4,
    //       median: 198,
    //       standardDeviation: 13.3,
    //       studentCount: 14
    //    }
    // ]
    const newDistrictAverages = state.get('districtAverages').withMutations((da) => {
        averages.forEach((avg) => {
            // the endpoint converts the grade data we send in:
            //       sometimes it changes 13 to K and sometimes it converts
            //       ints to strings
            const grade = avg.grade === 'K' ? 13 : parseInt(avg.grade);
            const key = toImmutable({
                termNumber: avg.termNumber,
                subject: avg.subject,
                grade,
            });
            const val = toImmutable({
                mean: avg.mean,
                median: avg.median,
                standardDeviation: avg.standardDeviation,
                count: avg.studentCount,
            });
            da.set(key, val);
        });
    });
    return state.set('districtAverages', newDistrictAverages);
}

export function storeRitQuintiles(state, ritQuintileData) {
    // this is the format of ritQuintileData:
    //{
    //    "termNumber": 201504,
    //    "subject": 2,
    //    "grade": 3,
    //    "weeks": 3,
    //    "percentile": 80,
    //    "schoolRit": 193,
    //    "studentRit": 201
    //}
    const newRitQuintiles = state.get('ritQuintiles').withMutations((q) => {
        ritQuintileData.forEach((rq) => {
            const key = toImmutable({
                termNumber: rq.termNumber,
                subject: rq.subject,
                grade: rq.grade,
                weeks: rq.weeks,
            });
            q.setIn([key, rq.percentile], rq.studentRit);
        });
    });
    return state.set('ritQuintiles', newRitQuintiles);
}

export function storeTermsInformation(state, response) {
    if (!response.terms) {
        throw new Error(`loadTerms: unexpected response: ${response}, did not contain terms`);
    }

    const terms = DataUtils.getUniqueRecords(toImmutable(response.terms), 'businessIdentifier');
    const currentTerm = findCurrentTerm(terms);
    const partnerHasFutureTerms = futureTermsSetup(currentTerm, terms);

    return state.withMutations((s) => {
        s.set('terms', terms);
        s.set('currentTerm', currentTerm);
        s.set('futureTermsSetup', partnerHasFutureTerms);
    });
}

export function storeCurrentAcademicYearInformation(state, response) {
    if (!response.terms) {
        throw new Error(`loadTerms: unexpected response: ${response}, did not contain terms for currentAcademicYear`);
    }

    const currentAcademicYear = toImmutable(response.terms);

    return state.withMutations((s) => {
        s.set('currentAcademicYear', currentAcademicYear);
    });
}

export function storeLinkingStudiesForPartner(state, studies) {
    const linkingStudies = studies.every((element) => element === null) ? null : toImmutable(studies);

    const linkingStudyList =
        linkingStudies instanceof Immutable.Map ? Immutable.List.of(linkingStudies) : linkingStudies;
    const sortedStudies = linkingStudyList ? linkingStudyList.sort(DataUtils.sortLinkingStudies) : toImmutable([]);

    return state.withMutations((s) => {
        s.set('linkingStudies', sortedStudies);
    });
}
